var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuttle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.68 135.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #707070;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 45.29,
    width: 15.33,
    height: 55.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.31,
    y: 104.58,
    width: 34.4,
    height: 17.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.39,
    y: 45.29,
    width: 15.33,
    height: 55.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.52,0c-9.5,0-17.2,23.58-17.2,33.08v8.47h34.4v-8.47c0-9.5-7.7-33.08-17.2-33.08Zm11.66,27.14c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5c0-2.32-3.05-4.28-6.66-4.28s-6.66,1.96-6.66,4.28c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5c0-5.2,5.12-9.28,11.66-9.28s11.66,4.07,11.66,9.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 122.2 24.16 122.2 24.16 67.24 0 106.49 0 122.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.52 122.2 96.68 122.2 96.68 106.49 72.52 67.24 72.52 122.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.89 135.78 57.15 135.78 62.14 126.7 34.89 126.7 39.89 135.78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttle);
export default __webpack_public_path__ + "static/media/shuttle.a2da196c4681a2eeba28c4b1af7d1c9d.svg";
export { ForwardRef as ReactComponent };